/**
 *
 * Asynchronously loads the component for Chat
 *
 */

import React from 'react';
import Loading from '@pisano/feedback-core/app/components/Loading';
import createLazyComponent from '@pisano/feedback-core/app/utils/createLazyComponent';

export default createLazyComponent({
  loader: () => import('./index'),
  fallback: (
    <div className="center-absolute">
      <Loading />
    </div>
  ),
});
